import { IControlState, IJoinArgs, MediaType } from "@interfaces/videocall/videocall";
import { useEffect, useState } from "react";

interface IControls
{
    onMute: (type: MediaType, enable: boolean) => void
    onLeave?: () => void,
    onExpand?: () => void,
    initialValues?: IJoinArgs
    audioOnly?: boolean,
    canShare?: boolean,
    isSharingScreen?: boolean
}

const Controls = (props: IControls) => {
    const [trackState, setTrackState] = useState<IControlState>({ 
        video: true, 
        audio: true,
        screen: false
    });

    useEffect(() => {
        console.debug("Controls started. Inital values", props.initialValues);
        if(!props.initialValues) return;
        setTrackState({
            ... props.initialValues,
            screen: false
        });
    }, [props.initialValues]);

    useEffect(() => {
        const isSharing = props.isSharingScreen === true;
        setTrackState((ps) => {
            return { ...ps, screen: isSharing };
        });
    }, [props.isSharingScreen]);

    const muteAudio = (isleave?:boolean) => {
        const enable = isleave ? false : !trackState.audio;
        setTrackState((ps) => {
            return { ...ps, audio: !ps.audio };
        });
        props.onMute("audio", enable);
    }

    const muteVideo = (isleave?:boolean) => {
        const enable = isleave ? false : !trackState.video;
        setTrackState((ps) => {
            return { ...ps, video: !ps.video };
        });
        props.onMute("video", enable);
    }

    const shareScreen = () => {
        const enable = !trackState.screen;
        props.onMute("screen", enable);
    }

    const onLeave = () => {
        if(props.onLeave)
            props.onLeave();
    }

    return (
        <div className="VideoCall__Actions">
            {/* Camera */}
            {
                !(props.audioOnly === undefined || props.audioOnly === true) &&
                <em className={`fas ${trackState.video ? "fa-video" : "fa-video-slash"}`}
                    onClick={() => muteVideo()} />
            }
            {/* Audio */}
            <em className={`fas ${trackState.audio ? "fa-microphone" : "fa-microphone-slash"}`}
                onClick={() => muteAudio()} />
            {/* Share screen */}
            {
                props.canShare &&
                    <em className={`fas ${trackState.screen ? "fa-rectangle-xmark" : "fa-arrow-up-from-bracket"}`}
                    onClick={() => shareScreen()} />
            }
            {
                props && props.onExpand &&
                    <em className="fas fa-expand"
                        onClick={props.onExpand} />
            }
            {
                props && props.onLeave &&
                    <em className="fas fa-phone-hangup" 
                        onClick={onLeave} />
            }
        </div>
    );
};

export default Controls;
